export default __webpack_public_path__ + "static/media/PartnerSolutions.2f670766.jpg";